import React, { FC } from "react";
import { RouteComponentProps, Switch, Redirect } from "react-router-dom";
import { EVENT_BASE_PATH, GREETING_CARD_PATH, EBIRTHDAY_CARD_CONTENT_LIST_PATH } from "../../../constants";
import PruRoute from "../../../../../common/components/PruRoute";
import ContentListPage from "./List";
import { ModulePermissionProps } from "../../../../../common/module/types";

const contentPath = `${EVENT_BASE_PATH}${GREETING_CARD_PATH}${EBIRTHDAY_CARD_CONTENT_LIST_PATH}`;

const ContentGreetingPage: FC<RouteComponentProps & ModulePermissionProps> = () => {
  return (
    <Switch>
      <Redirect exact from={contentPath}
        to={`${contentPath}/list`} />
      <PruRoute
        exact
        path={`${contentPath}/list`}
        render={(props) => (
          <ContentListPage
            {...props}
          />
        )}
      />
    </Switch>
  )
};

export default ContentGreetingPage;